import { Button } from "@mantine/core";
import { type ReactNode, useCallback } from "react";

import NavigationTile from "../NavigationTile/NavigationTile";
import styles from "./Card.module.scss";

interface ICardProps {
  children?: ReactNode;
  cardName: string;
  cardDetails?: string;
  bottomText?: string;
  data?: string;
  button?: string;
  isLoading?: boolean;
  onClick?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
}

const Card = ({
  cardName,
  cardDetails,
  onClick,
  button,
  bottomText,
  children,
  disabled,
  onDelete,
}: ICardProps) => {
  const handleDelete = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (onDelete) onDelete();
    },
    [onDelete],
  );

  const hasFooter = Boolean(onDelete || button || bottomText || children);

  return (
    <NavigationTile
      title={cardName}
      description={cardDetails}
      onClick={onClick}
      disabled={disabled}>
      {hasFooter ? (
        <>
          {(onDelete || button) && (
            <div className={styles.buttonContainer}>
              {onDelete && (
                <Button
                  data-testid="Button"
                  color="red"
                  variant="outline"
                  onClick={handleDelete}>
                  Delete
                </Button>
              )}
              {button && (
                <Button
                  data-testid="Button"
                  color={button === "pdf" ? "red" : "teal"}
                  variant="outline">
                  {button.toUpperCase()}
                </Button>
              )}
            </div>
          )}
          {bottomText && (
            <p className={styles.bottomText} data-testid="BottomText">
              {bottomText}
            </p>
          )}
          {children}
        </>
      ) : null}
    </NavigationTile>
  );
};

export default Card;
